export function formUtilValidateEmail(obj, event, email) {
  if (event.type === 'blur' || obj.isErrorDisplayed(email.error)) {
    const regex =
      /^(?=.{1,64}@)(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (regex.test(email.input.value)) {
      obj.hideError(email);
    } else {
      obj.showError(email);
    }
  }
}

export function formUtilIsErrorDisplayed(target: HTMLElement): boolean {
  return target.style.display === 'block';
}

export function formUtilHideError(obj, error, input, inputContainer): void {
  error.style.display = 'none';
  input.classList.remove(obj.cssClass.errorField);
  inputContainer.classList.remove(obj.cssClass.errorInputContainer);
}

export function formUtilTogglePasswordVisibility(eyeIcon, passwordInput): void {
  // reveal/conceal password
  const currentType = passwordInput.getAttribute('type');
  const newType = currentType === 'password' ? 'text' : 'password';

  passwordInput.setAttribute('type', newType);

  // switch icon
  const crossedIconClass = 'elc-eye-crossed-icon';
  const iconClass = 'elc-eye-icon';

  if (eyeIcon.classList.contains(crossedIconClass)) {
    eyeIcon.classList.remove(crossedIconClass);
    eyeIcon.classList.add(iconClass);
    eyeIcon.parentElement.setAttribute('aria-pressed', true);
  } else {
    eyeIcon.classList.remove(iconClass);
    eyeIcon.classList.add(crossedIconClass);
    eyeIcon.parentElement.setAttribute('aria-pressed', false);
  }
}
